import React, { useMemo } from 'react'
import { MapContainer, TileLayer, CircleMarker, Tooltip, /*useMap */ } from 'react-leaflet'
import { useEffect } from "react";
import L from "leaflet";
import "leaflet.heat";
import { useMap } from "react-leaflet";

function FixMapResize() {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 200);
  }, [map]);

  return null;
}

// Componente para animar el vuelo al punto seleccionado
/* function FlyToPoint({ center }) {
  const map = useMap()
  React.useEffect(() => {
    if (center) {
      map.flyTo(center, 8, { duration: 1.2 })
    }
  }, [center, map])
  return null
}*/
function HeatLayer({ puntos }) {
  const map = useMap();

  useEffect(() => {
    if (!puntos.length) return;

    const heatData = puntos.map(p => [
      p.LAT,
      p.LON,
      p.items[0]?.ET_CALCULADA || 0
    ]);

    const heat = L.heatLayer(heatData, {
      radius: window.innerWidth < 640 ? 15 : 25,
      blur: 15,
      maxZoom: 10
    }).addTo(map);

    return () => {
      map.removeLayer(heat);
    };
  }, [puntos, map]);

  return null;
}

export default function MapaET({ data, onPointClick, selectedCoords }) {
  // ✅ usar useMemo siempre, sin return temprano
  const puntos = useMemo(() => {
    if (!data || data.length === 0) return []
    const agrupado = {}

    data.forEach(row => {
      const key = `${row.LAT}_${row.LON}`
      if (!agrupado[key]) agrupado[key] = { LAT: row.LAT, LON: row.LON, items: [] }
      agrupado[key].items.push(row)
    })

    return Object.values(agrupado)
  }, [data])

  const centro = useMemo(() => {
    if (puntos.length > 0) {
      const lat = puntos.reduce((sum, p) => sum + p.LAT, 0) / puntos.length
      const lon = puntos.reduce((sum, p) => sum + p.LON, 0) / puntos.length
      return [lat, lon]
    }
    return [17.5, -91.25]
  }, [puntos])

  const getRepresentativeET = (items) => {
    if (!items || items.length === 0) return null;

    const latest = items
      .filter(i => i.ET_CALCULADA != null)
      .sort((a, b) => {
        if (a.YEAR !== b.YEAR) return b.YEAR - a.YEAR;
        return a.Month - b.Month;
      })[0];

    return latest?.ET_CALCULADA ?? null;
  };


  return (
    <div className="relative z-0 w-full h-full dashboard-card overflow-hidden">
      <MapContainer
        center={centro}
        zoom={9}
        doubleClickZoom={false}
        tap={true}
        style={{ height: "100%", width: "100%" }}
        >
        <FixMapResize />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <HeatLayer puntos={puntos} />

        {/*<FlyToPoint center={selectedCoords ? [selectedCoords.LAT, selectedCoords.LON] : null} />*/}

        {puntos.map((p, i) => {
          const repET = getRepresentativeET(p.items)
          return (
            <CircleMarker
              key={i}
              center={[p.LAT, p.LON]}
              radius={window.innerWidth < 640 ? 14 : 8}
              opacity={0}
              fillOpacity={0}
              eventHandlers={{
                click: () => onPointClick(p),
                touchstart: () => onPointClick(p)
              }}
            >
              <Tooltip direction="top" offset={[0, -8]} opacity={0.9}>
                <div className="text-sm">
                  <div><b>Lat:</b> {p.LAT.toFixed(3)}</div>
                  <div><b>Lon:</b> {p.LON.toFixed(3)}</div>
                  <div><b>ET (ej):</b> {repET != null ? repET.toFixed(2) : 'N/A'} mm/día</div>
                </div>
              </Tooltip>
            </CircleMarker>
          )
        })}
      </MapContainer>
    </div>
  )
}
